import React, { useEffect, useRef, useState } from 'react';
import logo from '../assets/laftek.png';
import heroVideo from '../assets/Can_you_generate_one_more_vide.mp4';
import { slides } from '../data';
import './HeroSlider.css';

const SLIDE_DURATION_MS = 8000;

export default function HeroSlider() {
  const [current, setCurrent] = useState(0);
  const [typedWord, setTypedWord] = useState('');
  const [typingIndex, setTypingIndex] = useState(0);
  const timerRef = useRef();
  const typingRef = useRef();

  const go = (idx) => {
    setCurrent((idx + slides.length) % slides.length);
  };

  useEffect(() => {
    timerRef.current = setInterval(() => setCurrent((value) => (value + 1) % slides.length), SLIDE_DURATION_MS);
    return () => clearInterval(timerRef.current);
  }, []);

  useEffect(() => {
    const words = slides[current].typingWords || [];

    setTypedWord('');
    setTypingIndex(0);

    if (!words.length) {
      return undefined;
    }

    let wordIdx = 0;
    let charIdx = 0;
    let deleting = false;

    const tick = () => {
      const activeWord = words[wordIdx];

      if (!deleting) {
        charIdx += 1;
        setTypedWord(activeWord.slice(0, charIdx));

        if (charIdx === activeWord.length) {
          deleting = true;
          typingRef.current = setTimeout(tick, 1400);
          return;
        }

        typingRef.current = setTimeout(tick, 80);
        return;
      }

      charIdx -= 1;
      setTypedWord(activeWord.slice(0, Math.max(charIdx, 0)));

      if (charIdx === 0) {
        deleting = false;
        wordIdx = (wordIdx + 1) % words.length;
        setTypingIndex(wordIdx);
        typingRef.current = setTimeout(tick, 200);
        return;
      }

      typingRef.current = setTimeout(tick, 38);
    };

    typingRef.current = setTimeout(tick, 250);

    return () => clearTimeout(typingRef.current);
  }, [current]);

  const highlight = (title, word) => {
    if (!word) return title;
    const parts = title.split(word);
    if (parts.length < 2) return title;

    return (
      <>
        {parts[0]}<span>{word}</span>{parts[1]}
      </>
    );
  };

  return (
    <section className="hero">
      <video className="hero-video" autoPlay muted loop playsInline aria-hidden="true">
        <source src={heroVideo} type="video/mp4" />
      </video>

      {slides.map((slide, i) => (
        <div
          key={slide.title}
          className={`slide ${i === current ? 'active' : ''}`}
        >
          <div className="slide-overlay">
            <div className="slide-layout">
              <div className="slide-content">
                <span className="slide-badge">{slide.badge}</span>
                <h1 className="slide-title">{highlight(slide.title, slide.titleHighlight)}</h1>
                {i === current && slide.typingWords?.length ? (
                  <div className="typing-line" aria-live="polite">
                    <span className="typing-prefix">Focused on</span>
                    <span key={`${current}-${typingIndex}`} className="typing-word">{typedWord || slide.typingWords[typingIndex]}</span>
                    <span className="typing-caret" />
                  </div>
                ) : null}
                <p className="slide-desc">{slide.desc}</p>
                <div className="slide-btns">
                  <a
                    href={slide.btn1.href}
                    className="btn-primary"
                    target={slide.btn1.external ? '_blank' : undefined}
                    rel={slide.btn1.external ? 'noreferrer' : undefined}
                  >
                    {slide.btn1.label}
                  </a>
                  <a
                    href={slide.btn2.href}
                    className="btn-outline"
                    target={slide.btn2.external ? '_blank' : undefined}
                    rel={slide.btn2.external ? 'noreferrer' : undefined}
                  >
                    {slide.btn2.label}
                  </a>
                </div>
              </div>

              
            </div>
          </div>
        </div>
      ))}



      <div className="slider-dots">
        {slides.map((slide, i) => (
          <button
            key={slide.title}
            className={`dot ${i === current ? 'active' : ''}`}
            onClick={() => go(i)}
          />
        ))}
      </div>
    </section>
  );
}
